import { render, staticRenderFns } from "./CprClaimOcr.vue?vue&type=template&id=cc7bacaa"
import script from "./CprClaimOcr.vue?vue&type=script&lang=js"
export * from "./CprClaimOcr.vue?vue&type=script&lang=js"
import style0 from "./CprClaimOcr.vue?vue&type=style&index=0&id=cc7bacaa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports